export const ROLES = {
  PATIENT: "PATIENT",
  DOCTOR: "DOCTOR",
  FRANCHISE: "FRANCHISE",
  CORDINATOR: "CORDINATOR",
  ADMIN: "ADMIN",
  SUBADMIN:"SUBADMIN"
};
